<template>
  <v-container class="pa-5" fluid>
    <v-card>
      <v-card-title>Service Lists</v-card-title>
      <v-divider class="mx-4"></v-divider>
      <v-card-text>
        <v-row dense>
          <v-col cols="12" md="12" lg="4">
            <v-text-field
              prepend-inner-icon="mdi-magnify"
              :placeholder="`Search`"
              :hide-details="true"
              solo
              clearable
              @input="onGridSearch"
              v-model="keyword"
              autocomplete="off"
              color="dark"
            ></v-text-field>
          </v-col>
          <v-col cols="6" sm="3" lg="2" class="align-right">
            <v-switch
              label="Show Deleted"
              v-model="showDeleted"
              @change="onGridSearch"
              color="dark"
              class="mt-2 ml-2 custom-width"
            ></v-switch>
          </v-col>
          <v-col cols="6" sm="2" lg="2">
            <v-select
              :items="listSize"
              label="No. of Rows"
              v-model="pageSize"
              @change="onGridSearch"
              class="page-size"
              color="dark"
            ></v-select>
          </v-col>
          <v-col
            cols="12"
            sm="7"
            md="7"
            lg="4"
            class="py-0"
            :class="$vuetify.breakpoint.xs ? 'mb-3' : ''"
          >
            <v-card
              class="d-flex justify-end mb-0"
              :class="$vuetify.breakpoint.xs ? 'flex-column mb-0' : 'flex-row'"
              flat
            >
              <v-card flat class="mb-0">
                <v-btn
                  color="dark"
                  @click="onExport"
                  dark
                  :class="$vuetify.breakpoint.xs ? 'mt-0' : 'mt-4'"
                  :width="$vuetify.breakpoint.xs ? '100%' : ''"
                  >Export Data</v-btn
                >
              </v-card>
              <v-card flat v-if="isAdmin">
                <v-btn
                  color="dark"
                  dark
                  class="mt-4"
                  @click="showAdd"
                  :class="$vuetify.breakpoint.xs ? 'ml-0' : 'ml-4'"
                  :width="$vuetify.breakpoint.xs ? '100%' : ''"
                  >Create Service</v-btn
                >
              </v-card>
            </v-card>
          </v-col>

          <v-col cols="12">
            <ag-grid-vue
              class="ag-theme-alpine"
              style="height: 60vh"
              :columnDefs="columnDefs"
              :defaultColDef="defaultColDef"
              :rowData="rowData"
              :gridOptions="gridOptions"
              rowSelection="single"
              @row-selected="onRowSelected"
              @grid-ready="onGridReady"
            >
            </ag-grid-vue>
          </v-col>
        </v-row>

        <v-dialog v-model="isEditable" width="80vw" persistent>
          <edit-service
            v-if="isEditable"
            ref="editService"
            :isAdding="true"
            :userService="userService"
            @saved="saveService"
            @cancel="cancel"
          ></edit-service>
        </v-dialog>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-alpine.css";
import { AgGridVue } from "ag-grid-vue";
import UserService from "@/models/UserService";

export default {
  name: "ServiceList",
  data: () => ({
    userService: new UserService(),
    columnDefs: [
      { headerName: "Wholesaler", field: "company" },
      {
        headerName: "Radius",
        width: 120,
        field: "radiusServiceId",
        sort: "desc",
        hide: true,
      },
      {
        headerName: "Service ID",
        field: "serviceId",
        cellRenderer: function (params) {
          if (params.data.isDeleted)
            return `<span style="color: red;">${params.value} &#9864;</span>`;
          return params.value;
        },
      },
      { headerName: "Service Name", field: "serviceName" },
      { headerName: "Description", field: "serviceDescription" },
      {
        headerName: "Address",
        field: "serviceAddress",
        valueGetter: function (params) {
          let street = params.data.serviceStreet ? params.data.serviceStreet : "";
          let city = params.data.serviceCity ? params.data.serviceCity : "";
          return `${street} ${city}`.trim();
        },
      },
      { headerName: "Username", field: "username" },
      { headerName: "Password", field: "password" },
      { headerName: "Static IP",
        field: "staticIP",
        valueGetter: function (params) {
          let staticIP = params.data.staticIP ? params.data.staticIP : "";
          let ipRange = params.data.ipRange ? params.data.ipRange : "";
          return staticIP || ipRange;
        },
      },
      // {
      //   headerName: "Status",
      //   field: "session",
      //   cellRenderer: function(params) {
      //     if (params.value) {
      //       let date = new Date(`${params.value.lastLogTime}`);
      //       date = new Date(date.toString().replace("Standard", "Daylight"));
      //       return `${date.toLocaleDateString(
      //         "en-AU"
      //       )} ${date.toLocaleTimeString()} AEDT`;
      //     }
      //   }
      // }
    ],
    defaultColDef: {
      sortable: true,
      filter: true,
      resizeable: true,
    },
    showDeleted: false,
    isEditable: false,
    rowData: [],
    gridApi: null,
    gridColumnApi: null,
    gridOptions: {},
    keyword: "",
    pageSize: 50,
    listSize: [
      {
        text: "10",
        value: 10,
      },
      {
        text: "30",
        value: 30,
      },
      {
        text: "50",
        value: 50,
      },
      {
        text: "100",
        value: 100,
      },
      {
        text: "Show All",
        value: -1,
      },
    ],
  }),
  components: { AgGridVue },
  mounted() {
    this.gridApi = this.gridOptions.api;
    this.gridColumnApi = this.gridOptions.columnApi;
    if (this.isAdmin)
      this.gridColumnApi.applyColumnState({
        state: [
          {
            colId: "radiusServiceId",
            hide: !this.isAdmin,
          },
        ],
      });
  },
  methods: {
    manageRow(item) {
      let vm = this;
      vm.pageSize(item).then((data) => {
        vm.rowData = data;
        vm.gridApi.sizeColumnsToFit();
      });
    },
    onGridReady(args) {
      let vm = this;
      vm.gridApi = args.api;
      args.api.sizeColumnsToFit();
    },
    onRowSelected(data) {
      let vm = this;
      vm.setAvailableService(data.data);
      vm.$router.push(`/service-details/${data.data.radiusServiceId}`);
    },
    onGridSearch() {
      let vm = this;

      clearTimeout(this._timerId);
      this._timerId = setTimeout(() => {
        vm.getNbnServices({
          search: vm.keyword,
          showDeleted: vm.showDeleted,
          pageSize: vm.pageSize,
        })
          .then((data) => {
            vm.rowData = data;
            vm.gridApi.sizeColumnsToFit();
          })
          .catch(() => {});
      }, 500);
    },
    onExport() {
      let vm = this;
      vm.gridApi.exportDataAsCsv();
    },
    showAdd() {
      let vm = this;
      vm.$store.dispatch("service/createEmptyService");
      vm.isEditable = true;
    },

    cancel() {
      let vm = this;
      vm.isEditable = false;
    },
  },
  beforeMount() {
    let vm = this;
    vm.search = 50;
    vm.resetAvailableService();
    vm.getNbnServices({ showDeleted: vm.showDeleted })
      .then((data) => {
        vm.rowData = data;
      })
      .catch(() => {
        // vm.store.dispatch("auth/authenticate");
      });

    vm.getRatePlans().then((data) => {});
  },
};

window.isDeleted = function isDeleted(args) {
  if (args.data.isDeleted) return `${args.data.radiusServiceId} <b>Removed</b>`;
  return `${args.data.radiusServiceId}`;
};
</script>

<style>
.page-size {
  width: 200px;
  float: left;
}

.custom-width {
  width: 150px !important;
}
</style>
